import React, { FC, useEffect, useRef, useState } from "react";
import clsx from "clsx";
import { useTranslation } from "react-i18next";

import { useAddNotificationMutation } from "~/schemas/generated/graphql";
import { NOTIFICATIONS } from "~/constans/notifications";

import Button from "~/shared/ui/Fields/Button";
import Input from "~/shared/ui/Fields/Input";
import Preloader from "~/components/Preloader";

import Download from "~/components/Icons/icon-download-2";
import Upload from "~/components/Icons/icon-download";
import Edit from "~/components/Icons/icon-edit-2";
import Add from "~/components/Icons/icon-add";
import Document from "~/components/Icons/icon-document-2";
import s from "./FileLoader.less";
import { useSetLocationData } from "~/hooks/locationData";
import IconPdf from "~/components/Icons/mimeType/icon-pdf";
import Delete from "~/components/Icons/Delete";
import { uploadFile } from "~/libs/uploadFile";
import PdfIcon from "../Icons/svg/pdf";
import DocxIcon from "../Icons/svg/docx";
import DeleteIcon from "../Icons/svg/delete";

export type fileDownload = {
  id: string;
  link: string;
};

interface IProps {
  name?: string;
  id?: string;
  setValue?;
  setLoad?;
  deleteFile?;
  accept?: string;
  withButton?: boolean;
  withIMG?: boolean;
  withText?: boolean;
  isNoneUpload?: boolean;
  isNewStyle?: boolean;
  isNewStyleScan?: boolean;
  error?: string;
  disabled?: boolean;
  label?: string;
  titleDownload?: string;
  download?;
  setImg?;
  likeObj?;
  watch?;
  control;
  sizeRestrictions?: number;
  showErrorHandler?;
  customErrorStyle?;
  handleIsFullToState?: (isBool: boolean) => void;
  iconZIndexControlClass?;
}

const FileLoader: FC<IProps> = ({
  name,
  id = "",
  setValue,
  setImg,
  watch,
  setLoad = () => {},
  deleteFile,
  accept = "*/*",
  withButton = false,
  isNoneUpload = false,
  isNewStyle = false,
  isNewStyleScan = false,
  withIMG = false,
  withText = false,
  likeObj = false,
  error = "",
  disabled = false,
  label = "",
  titleDownload = "",
  download = null,
  control,
  sizeRestrictions,
  showErrorHandler = () => {},
  customErrorStyle,
  handleIsFullToState,
  iconZIndexControlClass,
}) => {
  const { t } = useTranslation();
  const setData = useSetLocationData();
  const [loadingUpload, setLoadingUpload] = useState(false);
  const [linkFromServer, setLinkFromServer] = useState("");
  const [nameFromServer, setNameFromServer] = useState("");
  const inputEl = useRef(null);

  useEffect(() => {
    if (watch === "") {
      setLinkFromServer("");
    }
  }, [watch]);

  const imgArr =
    withIMG &&
    linkFromServer &&
    !isNoneUpload &&
    setImg &&
    linkFromServer.split(".");

  const isImage = (optionOneName) => {
    switch (imgArr[imgArr.length - 1]) {
      case "pdf":
        return <IconPdf />;
      default:
        return <img src={optionOneName} />;
    }
  };

  useEffect(() => {
    if (download) {
      if (typeof download === "string") {
        setLinkFromServer(download);
      } else {
        setLinkFromServer(download.link);
        setNameFromServer(download.name);
      }
    } else if (deleteFile) {
      setLinkFromServer("");
    }
  }, [download]);

  useEffect(() => {
    if (withText) {
      if (linkFromServer) {
        setData("isFull", true);
      } else {
        setData("isFull", "");
      }
    }
  }, [linkFromServer]);

  useEffect(() => {
    if (handleIsFullToState && withText && linkFromServer) {
      handleIsFullToState(true);
    }
  }, [handleIsFullToState, withText, linkFromServer]);

  const [addNotificationMutation] = useAddNotificationMutation({});
  const onUploadComplete = (uploadedFile) => {
    const { id, link, name: nameFile } = uploadedFile;
    setValue(name, setImg ? (likeObj ? { link, id, name } : link) : id);
    setLinkFromServer(link);
    setNameFromServer(nameFile);
    addNotificationMutation({
      variables: {
        type: NOTIFICATIONS.success,
        content: t("common.file_uploaded_successfully"),
      },
    });
    setLoadingUpload(false);
  };

  const errorNotification = () => {
    addNotificationMutation({
      variables: {
        type: NOTIFICATIONS.error,
        content: t("common.data_uploaded_error_size"),
      },
    });
  };

  const fallBack = () => {
    addNotificationMutation({
      variables: {
        type: NOTIFICATIONS.error,
        content: t("common.data_uploaded_error"),
      },
    });
  };

  const upload = async (file) => {
    setLoadingUpload(true);
    try {
      const uploadedFile = await uploadFile(file as File, fallBack);
      if (uploadedFile) onUploadComplete(uploadedFile);
    } catch (error) {
      if (error.response && error.response.data.message === "File too large") {
        errorNotification();
      } else {
        fallBack();
      }
      setLoadingUpload(false);
    }
  };

  const uploadFileProcess = (target, file) => {
    if (file && sizeRestrictions) {
      const x = BigInt(Number(`${sizeRestrictions}e+6`));
      if (x > file.size) {
        upload(file);
        showErrorHandler(true);
        return;
      }
    }
    file && upload(file);
  };

  const onButtonClick = () => {
    inputEl.current.click();
  };

  const deleteScan = () => {
    deleteFile();
    setLinkFromServer("");
    setNameFromServer("");
    setValue(name, null);
  };

  return (
    <>
      {loadingUpload && <Preloader noText />}
      {withButton &&
        (linkFromServer ? (
          isNewStyleScan ? (
            <div
              className={clsx(s.isDownLoadNew, {
                [s.isFileManagment]: deleteFile,
              })}
            >
              <div className={s.titleNewStyle}>{titleDownload}</div>

              <div className={s.wrapBtn}>
                <div>
                  {nameFromServer &&
                  (nameFromServer?.endsWith(".doc") ||
                    nameFromServer?.endsWith(".docx")) ? (
                    <DocxIcon />
                  ) : nameFromServer?.endsWith(".pdf") ? (
                    <PdfIcon />
                  ) : (
                    <Document />
                  )}
                  <a target="_blank" href={linkFromServer}>
                    {nameFromServer}
                  </a>
                </div>
                {!isNoneUpload && !disabled && (
                  <Button
                    customClassName={s.editBtn}
                    txtBtn={"Заменить"}
                    onClick={onButtonClick}
                  >
                    <Edit />
                  </Button>
                )}
                {deleteFile && download && !disabled && (
                  <Button
                    customClassName={s.deleteBtn}
                    txtBtn={"Удалить"}
                    onClick={deleteScan}
                  >
                    <DeleteIcon />
                  </Button>
                )}
              </div>
            </div>
          ) : (
            <div
              className={clsx(s.isDownLoad, {
                [s.isFileManagment]: deleteFile,
              })}
            >
              <Document />
              <a target="_blank" href={linkFromServer}>
                {titleDownload || nameFromServer}
              </a>
              {!isNoneUpload && !disabled && (
                <Button
                  customClassName={s.save_changes}
                  txtBtn={""}
                  onlyIcon
                  onClick={onButtonClick}
                >
                  <Edit />
                </Button>
              )}
              {deleteFile && download && (
                <Button
                  customClassName={s.delete_changes}
                  txtBtn={""}
                  onlyIcon
                  onClick={deleteFile}
                >
                  <Delete />
                </Button>
              )}
            </div>
          )
        ) : !isNoneUpload && isNewStyleScan ? (
          <div
            className={clsx(s.isDownLoadNew, {
              [s.isFileManagment]: deleteFile,
            })}
          >
            <div className={s.titleNewStyle}>{label}</div>

            {!disabled && (
              <div className={s.wrapBtn}>
                <Button
                  customClassName={s.downloadBtn}
                  txtBtn={t("ui.upload")}
                  onClick={onButtonClick}
                >
                  <Download />
                </Button>
              </div>
            )}
          </div>
        ) : (
          <div className={s.notDownLoad}>
            <p>{label}</p>
            <Button
              txtBtn={t("ui.upload")}
              orange
              small
              customClassName={s.save_changes}
              onClick={onButtonClick}
            >
              <Download />
            </Button>
          </div>
        ))}

      {setImg &&
        withIMG &&
        linkFromServer &&
        !isNoneUpload &&
        isImage(linkFromServer)}
      {isNewStyle ? (
        !setImg && withIMG && linkFromServer ? (
          <>
            <img src={`${linkFromServer}`} />
            {!disabled && (
              <div className={s.editIcon}>
                <Edit color={"#E37639"} />
              </div>
            )}
            {deleteFile && download && !disabled && (
              <Button
                customClassName={s.deleteBtnImg}
                onlyIcon
                onClick={deleteScan}
              >
                <DeleteIcon />
              </Button>
            )}
          </>
        ) : (
          <div className={s.wrapNoneImg}>
            Добавить фото
            <div className={s.iconNoneImg}>
              <Add />
            </div>
          </div>
        )
      ) : (
        !setImg &&
        withIMG &&
        linkFromServer && <img src={`${linkFromServer}`} />
      )}
      {withText && linkFromServer && !loadingUpload && (
        <div className={s.isDownLoad}>
          <div className={s.textDownload}>
            {nameFromServer}
            <input
              className={clsx({
                [s.upload_file]: true,
                [s.withButton]: withButton,
              })}
              id={id}
              title=""
              type="file"
              name="file"
              onChange={(e) => uploadFileProcess(e.target, e.target.files[0])}
              accept={accept}
              ref={inputEl}
            />
          </div>

          <a
            target="_blank"
            href={linkFromServer}
            className={iconZIndexControlClass}
          >
            <Button customClassName={s.save_changes} txtBtn={""} onlyIcon>
              <Upload fill={"#878E94"} />
            </Button>
          </a>
        </div>
      )}
      {(!withText || !linkFromServer) && !isNoneUpload && (
        <input
          className={clsx({
            [s.upload_file]: true,
            [s.withButton]: withButton,
            [s.disabledCursor]: disabled,
          })}
          type="file"
          name="file"
          id={id}
          title={""}
          disabled={disabled}
          onChange={(e) => uploadFileProcess(e.target, e.target.files[0])}
          accept={accept}
          ref={inputEl}
        />
      )}

      <Input
        name={name}
        error={error}
        control={control}
        customClassName={s.hidden_input}
        defaultValue={download?.id || ""}
      />
      {error && (
        <div
          className={clsx(s.error, {
            [customErrorStyle]: customErrorStyle,
          })}
        >
          {" "}
          {error}{" "}
        </div>
      )}
    </>
  );
};
export default FileLoader;
